import React from "react";
import AnimationOpen from "./AnimationOpen";

const NoData = ({ children }) => {
  return (
    <AnimationOpen>
      <div
        style={{
          paddingLeft: "32px",
          color: "#888",
          fontStyle: "italic",
          margin: "10px 0px",
        }}
        className="project-banner"
      >
        {children}
      </div>
    </AnimationOpen>
  );
};

export default NoData;
